module.exports = __webpack_public_path__ + "img/polttopuusuoja_original.f3cf44f3.jpg";